import { StyleSheet } from 'react-native-web';
import { colors } from '../../global-styles';

export default StyleSheet.create({
  container: {
    width: '15rem',
    margin: '0.5rem',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  title: {
    fontWeight: 700,
    fontSize: '19px',
    lineHeight: '25px',
  },
  infoButton: {
    paddingTop: '0.3rem',
    paddingLeft: '0.7rem',
  },
  contactTitle: {
    paddingTop: '0.7rem',
    fontWeight: 'bolder',
    paddingBottom: '0.3rem',
  },
  contactName: {
    fontWeight: 'bold',
  },
  link: {
    color: colors.linkBlue,
  },
});
